import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Dr. Thomas Schwenk',
  role: 'Inhaber / Ästhetik & Funktion'
}, {
  name: 'Dr. Markus Striegel',
  role: 'Inhaber / Ästhetik & Funktion'
}, {
  name: 'Dr. Johanna Herzog M.Sc.',
  role: 'Inhaberin / Kieferorthopädie'
}];
export function TeamSection() {
  return <section className="py-32 bg-weiss" data-id="element-191">
      <div className="max-w-7xl mx-auto px-6" data-id="element-192">
        <div className="mb-20 max-w-2xl" data-id="element-193">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading text-schwarz mb-6" data-id="element-194">
            Unser Team
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-warm-gray font-body" data-id="element-195">
            Ihre Zahnärztinnen und Zahnärzte in Nürnberg, Fürth und Erlangen.
            Bei uns arbeiten ausnahmslos Experten, die in ihrem jeweiligen
            Fachgebiet über herausragende Expertise verfügen.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-196">
          <motion.div className="lg:col-span-7 relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] lg:aspect-auto lg:h-[600px]" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-197">
            <img src="https://cdn.magicpatterns.com/uploads/6c7CUiManAy12hB19aTAgd/Chefs_komprimiert.jpg" alt="Das Inhaber-Team von edel & weiss" className="w-full h-full object-cover object-top" data-id="element-198" />
          </motion.div>

          <div className="lg:col-span-5 flex flex-col space-y-10" data-id="element-199">
            {team.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.8,
            delay: index * 0.2
          }} data-id="element-200">
                <h3 className="text-2xl md:text-3xl font-heading text-schwarz mb-2" data-id="element-201">
                  {member.name}
                </h3>
                <p className="text-royal-blue text-base font-body font-medium" data-id="element-202">
                  {member.role}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}